import { FETCH_BIKEMODELS_FAILURE, FETCH_BIKEMODELS_REQUEST, FETCH_BIKEMODELS_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const bikeModelsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BIKEMODELS_REQUEST:
            return {
                ...state,
            }
        case FETCH_BIKEMODELS_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_BIKEMODELS_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}